import http from "../../http-common";

class CatalogPathService {
    getCatalogPath(path: string) {
        return http.get(`/education/catalog?path=${path}`);
    }
}

export default new CatalogPathService();
